import { useState, useEffect } from "react"
import { ArticleData } from "../../../../../articlePage/stateInterfaces"
import { SiteSimpleImage } from "../../../../commonComponents/inline/siteSimpleImage"
import { secondsToMinutes } from "../../../../siteWidgets/siteWidgetUtils"
import { PodcastPlayer } from "../../../radioWidgets/floatingPlayer/podcastPlayerButton"
import { DateDisplay } from "../../../../commonComponents/inline/dateDisplay/dateDisplay"
import { SiteArticleSocialShareNew1280 } from "../../../article/componentas/articleSocialShare1280Component/articleSocialShareNew1280"
import { SignUpForPodcast } from "../../../radioWidgets/articleAudioPodcast/components/signupForPodcast"
import { ArticleAppHeaderShareComponent } from "../../../article/componentas/articleHeaderComponenta/articleAppHeaderShareComponent"
import { ArticleImageSlider } from "../../../calcalistWidgets/articleImageGallery/components/articleImageSlider"
import { imageListGalleryCalcalist } from "../../../calcalistWidgets/articleImageGallery/components/articleImageSliderEditor"
import { MediaVideoData } from "../../../../../media/interfaces"
import { SiteVideoMedia } from "../../../../siteWidgets/siteMedia"
import { SiteVideoData } from "../../../../interfaces"
import { MediaContentTypes } from "../../../../../constants/contentTypes"
import { VideoBehaiforData } from "../../../../commonDataObjects/interfaces"


interface AudioPodcastPlayerProps {
    title: string
    subTitle?: string
    category: string
    categoryId?: string
    audioUrl: string
    durationSeconds: number
    imageUrl: string
    isMobileWeb?: boolean
    articleLink?: string
    articleData?: ArticleData
    description?: string
    publishedDate?: Date
    authorName?: string
    isApp?: boolean
    shouldAudioGalleryDisplay?: boolean
    imageList?: imageListGalleryCalcalist[]
    video?: MediaVideoData
    videoBehaivior?: Partial<VideoBehaiforData>
    hideVideoAds?: boolean
    domain?: string
    podcastName?: string
    podcastBgColor?: string
    podcastCategoryImage?: string
    componentaId?:string
}


declare const window: Window & {
    shouldAudioAutoplay?: boolean;
    shouldDisplayBgInPlayer?: boolean;
    shouldAudioVideoAutoplay?: boolean
}


export const AudioBepoPodcastPlayer = (props: AudioPodcastPlayerProps) => {
    const [showDescription, setShowDescription] = useState(false)
    const [shouldDisplayBgInPlayer, setShouldDisplayBgInPlayer] = useState(typeof window !== "undefined" && window.shouldDisplayBgInPlayer);
    const { domain, video, videoBehaivior, hideVideoAds, imageList, title, subTitle, category, categoryId, audioUrl, durationSeconds, imageUrl, isMobileWeb, isApp, articleLink, description, publishedDate, authorName, shouldAudioGalleryDisplay } = props
    const podcastDuration = secondsToMinutes(video ? video.duration : durationSeconds, "דק'");
    const browserDisplayMediaMetaData = { title: title, artist: "Bepo", album: category }
    const openPodcastPlayer = (id: string, isVideo: boolean) => {
        if (isVideo) {
            window.location.href = `${domain}/video?path=${video.main_link}?videoId=${video.mediaVideoId}&articleId=${props.articleData.articleId}&advertisement=${hideVideoAds ? '0' : '1'}&blockAbroad=${video.blockAbroadViews ? `1` : `0`}${video.aspectRatio ? `&proportion=${video.aspectRatio}` : ""}${video.category.id ? `&category_id=${video.category.id}` : ""}${`&caption=${video.videoName}`}`;
        }
        else {
            window.location.href = `//podcast/${id}`
        }

    }
    const shouldAudioAutoplay = typeof window !== "undefined" && (video !== undefined ? window.shouldAudioVideoAutoplay : window.shouldAudioAutoplay);
    const toggleShowDescription = () => {
        const { isMobileWeb, isApp } = props
        setShowDescription(!showDescription);
        getClickedBtnText(showDescription ? "collapse" : "expand");
        const element = document.querySelector(".podcast-text.collapsed")
        if (element && (isMobileWeb || isApp)) {
            element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        }
    }
    const getClickedBtnText = (text) => {
        if (typeof window != "undefined" && window.Android) {
            window.Android.onClickTextChange(text)
        }
        if (typeof window != "undefined" && window.webkit && window.webkit.messageHandlers) {
            window.webkit.messageHandlers.onClickTextChange.postMessage(text);
        }
    }
    useEffect(() => {
        isApp && shouldAudioAutoplay && openPodcastPlayer(props.articleData.articleId, video !== undefined);
    }, [isApp, props.articleData.articleId, shouldAudioAutoplay, video]);

    useEffect(() => {
        if (!isApp) {
            return;
        }

        // Monitor window.shouldDisplayBgInPlayer and update state when it changes
        const checkBgDisplay = () => {
            const windowValue = !!(typeof window !== "undefined" && window.shouldDisplayBgInPlayer);
            setShouldDisplayBgInPlayer(windowValue);
        };

        // Check at intervals in case the value changes
        const timer1 = setTimeout(checkBgDisplay, 100);
        const timer2 = setTimeout(checkBgDisplay, 500);
        const timer3 = setTimeout(checkBgDisplay, 1000);
        const timer4 = setTimeout(checkBgDisplay, 2000);
        const timer5 = setTimeout(checkBgDisplay, 3000);

        return () => {
            clearTimeout(timer1);
            clearTimeout(timer2);
            clearTimeout(timer3);
            clearTimeout(timer4);
            clearTimeout(timer5);
        };
    }, [isApp]);




    const videoData: SiteVideoData = video ? {
        mediaType: MediaContentTypes.MEDIA_VIDEO,
        url: video.main_link,
        downGradeUrl: video.low_res_link,
        poster: video.posterSrc,
        isPlayerBarVisible: videoBehaivior !== undefined ? videoBehaivior.isPlayerBarVisible : true,
        isAutoPlaying: videoBehaivior !== undefined ? videoBehaivior.isAutoPlaying : false,
        isLoopPlaying: videoBehaivior !== undefined ? videoBehaivior.isLoopPlaying : false,
        isMuteAvailable: videoBehaivior !== undefined ? videoBehaivior.isMuteAvailable : false,
        isSoundButtonVisible: videoBehaivior !== undefined ? videoBehaivior.isSoundButtonVisible : true,
        isBigVideo: true,
        youtube_id: "",
        height: 578,
        width: 776,
        mediaId: video.mediaVideoId,
        blockAbroadViews: video.blockAbroadViews,
        credit: video.credit,
        title: video.videoName,
        aspectRatio: video.aspectRatio,
        duration: video.duration,
        categoryId: video.category ? video.category.id : ""
    } : undefined;
    const scriptObj = {
        id: props.articleData.articleId,
        name: authorName,
        title: title,
        durationSeconds: durationSeconds,
        imageUrl: imageUrl,
        audioUrl: audioUrl,
        articleLink: articleLink,
        podcastCategoryImage: props.podcastCategoryImage,
        podcastName: props.podcastName

    };
    // For app mode, directly check window value to avoid state timing issues
    const finalShouldDisplayBg = isApp ? (typeof window !== "undefined" && window.shouldDisplayBgInPlayer) : shouldDisplayBgInPlayer;

    const scriptObjVideo = {
        podcastName: props.podcastName,
        name: authorName,
        title: title,
        podcastCategoryImage: props.podcastCategoryImage,
        ...(finalShouldDisplayBg && props.podcastBgColor ? { podcastBgColor: props.podcastBgColor } : {})
    }


    const scriptStringVideo = isApp && video
        ? `setTimeout(function() {
            window.podcastsData = window.podcastsData || {};
            var podcastData = {
                podcastName: ${JSON.stringify(props.podcastName)},
                name: ${JSON.stringify(authorName)},
                title: ${JSON.stringify(title)},
                podcastCategoryImage: ${JSON.stringify(props.podcastCategoryImage)}
            };
            if (window.shouldDisplayBgInPlayer) {
                var bgColor = ${JSON.stringify(props.podcastBgColor)};
                if (bgColor) {
                    podcastData.podcastBgColor = bgColor;
                }
            }
            window.podcastsData["${props.articleData.articleId}"] = podcastData;
        }, 100);`
        : `window.podcastsData = window.podcastsData || {};
            window.podcastsData["${props.articleData.articleId}"] = ${JSON.stringify(scriptObjVideo)};`;

    const scriptString = video ? scriptStringVideo : `window.podcastsData = window.podcastsData || {};
        window.podcastsData["${props.articleData.articleId}"] = ${JSON.stringify(scriptObj)};`
    const videoScript = <script type="text/javascript" dangerouslySetInnerHTML={{ __html: scriptString }} />

    return (
        <div className={video ? "audio-podcast-player-bepo includeVideo" : "audio-podcast-player-bepo"}>
            <div className="audio-podcast-player-container">
                {video ? <div className="podcast-video">
                    {isApp ?
                        <> {videoScript}
                            <a className='tvVideo_wraper tvVideo_wraper_new_design' href={`${domain}/video?path=${video.main_link}?videoId=${video.mediaVideoId}&articleId=${props.articleData.articleId}&advertisement=${hideVideoAds ? '0' : '1'}&blockAbroad=${video.blockAbroadViews ? `1` : `0`}${video.aspectRatio ? `&proportion=${video.aspectRatio}` : ""}${video.category.id ? `&category_id=${video.category.id}` : ""}${`&caption=${video.videoName}`}`}>
                                <img
                                    width='100%'
                                    src={video.posterSrc}
                                    alt='ןעוט...'
                                    title='ןעוט...'
                                    border='0' />
                                <div style={{ backgroundSize: "50px 50px" }} className={"playButton"}
                                />

                            </a></> :
                        <SiteVideoMedia
                            data={videoData}
                            videoSettings={{ hideVideoAds: hideVideoAds }}
                            runArticleAutoPlayLogic={false}
                            videoShareLink={""}
                            preload={!hideVideoAds ? "metadata" : "none"}
                            popupText={""}
                            copyUrl={""}
                            siteLayoutType={""}
                            videoCategoryId={videoData.categoryId}
                        />}
                </div> : <div className="podcast-image">
                    <SiteSimpleImage src={imageUrl} />
                    {isApp ? <div className="podcastPlayBtnContainer">
                        <a className="podcastPlayBtn" href={`//podcast/${scriptObj.id}`} ></a>
                        <script type="text/javascript" dangerouslySetInnerHTML={{ __html: scriptString }} />
                    </div> : <PodcastPlayer
                        audioUrl={audioUrl}
                        title={title}
                        isMobileWeb={isMobileWeb}
                        className="audio-play-button-bepo"
                        durationSeconds={durationSeconds}
                        browserDisplayMediaMetaData={browserDisplayMediaMetaData}
                        articleLink={articleLink}
                        articleData={props.articleData}
                        rangeThumbColor={"#DF3232"}
                        rangeColor={"#BBBBBB"}
                        rangeProgressColor={"#DF3232"}
                        shouldAudioAutoplay={shouldAudioAutoplay}
                    />}
                    <SignUpForPodcast className="bepo" categoryId={categoryId} />
                </div>}
                <div className="podcast-container-details">
                    <div className="podcast-title">{title}</div>
                    <div className="podcast-subtitle">{subTitle}</div>
                    <div className="podcast-details">
                        <span className="duration">{podcastDuration}</span>
                        <span className="publishedDate">פורסם <DateDisplay date={publishedDate} /></span>
                        {isApp ? <ArticleAppHeaderShareComponent isMagazineArtice={true} showComments={false} /> : <SiteArticleSocialShareNew1280
                            categorySubChannel={""}
                            author={""}
                            articleId={""}
                            isBottomButtons={false}
                            showComments={false}
                            isMobile={false}
                            isSpotim={false}
                            lang={"he"}
                            audioArticle={true} />}
                        {(description || shouldAudioGalleryDisplay) && <button className={isApp ? 'toggle-description-pf' : `toggle-description`} onClick={toggleShowDescription}>
                            <span className="toggle-desc-text-pf">{showDescription ? "צמצום" : "קראו עוד"}</span>
                            <span className={`${isApp ? 'icon-pf' : 'icon'} ${showDescription ? "expanded" : "collapsed"}`} />
                        </button>}
                    </div>

                </div>


                {(description || shouldAudioGalleryDisplay) && <div className={`podcast-text ${showDescription ? "expanded" : "collapsed"}`}>
                    <span>{description}</span>
                    {shouldAudioGalleryDisplay && <div className={"AudioMediaGallery"} id="AudioMediaGallery">
                        <ArticleImageSlider imageSliderWidth={"unset"} imageList={imageList} infinite={false}
                        componentaId={"audio_gallery"}
                        shouldEnableFullScreenGallery={true}
                         width={"auto"} height={"auto"} style={{ background: "transparent" }} isApp={isApp} 
                         isMobileWeb={isMobileWeb} articleId={props.articleData.articleId} 
                        isRtl={true} />
                    </div>
                    }
                </div>}
            </div>


        </div>
    )
}
AudioBepoPodcastPlayer.siteScriptName = "AudioBepoPodcastPlayer"